export enum Sizes {
    large = 'large',
    medium50 = 'medium50',
    medium = 'medium',
    small = 'small',
    xsmall = 'xsmall',
}
export type Size = `${Sizes}`;
